import './App.css';
import React, { StrictMode } from 'react';
import LoginForm from './Components/Login/Login';
import LayoutMap from './Components/Layout/LayoutMap';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import Registration from './Components/Registration/Registration';
import LayoutDevices from './Components/Layout/LayoutDevices';
import LayoutSettings from './Components/Layout/LayoutSettings';
import LayoutReports from './Components/Layout/LayoutReports';
import ForgotPasswordForm from './Components/Login/ForgotPass';
import ResetPasswordForm from './Components/Login/ResetPass';
import { UserProvider, useUser } from './Context/UserContext';
import { Layout } from './Components/Layout/Layout';


const App = () => {

  const { user, setUser, fetchUserData, loading } = useUser();

  const handleLogin = async () => {
    await fetchUserData();
  };

  // Показываем загрузку во время проверки аутентификации
  if (loading) {
    return (
      <div className="App">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div>Загрузка...</div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={user ? <Navigate to="/devices" /> : <LoginForm onLogin={handleLogin} />}
          />
          <Route
            path="login"
            element={user ? <Navigate to="/devices" /> : <LoginForm onLogin={handleLogin} />}
          />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />

          {/* <Route
            path="registration"
            element={user ? <Navigate to="/devices" /> : <Registration />}
          /> */}

          <Route
            path="*"
            element={
              user ? (
                <>
                  {/* <div className={s.main}>
                    <Header /> */}
                  <Routes>
                    <Route path="map" element={
                      <Layout>
                        <LayoutMap />
                      </Layout>
                    } />
                    <Route path="devices" element={
                      <Layout>
                        <LayoutDevices />
                      </Layout>
                    } />
                    <Route path="device/:id" element={
                      <Layout>
                        <LayoutDevices />
                      </Layout>
                    } />
                    <Route path="reports" element={
                      <Layout>
                        <LayoutReports />
                      </Layout>
                    } />
                    <Route path="settings" element={
                      <Layout>
                        <LayoutSettings />
                      </Layout>
                    } />
                    <Route path="devices" element={
                      <Layout>
                        <LayoutDevices />
                      </Layout>
                    } />
                  </Routes>
                  {/* </div> */}
                </>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>

      </div>
    </Router>
  );
}

export default function Root() {
  return (
    <UserProvider>
      <App />
    </UserProvider>
  );
}
